module.exports = __webpack_public_path__ + "static/media/pic-st4.a72743ea.jpg";